<template>
  <b-container justify="center" fluid>
    <b-row class="mb-2 mt-1" v-if="editMode">
      <b-col>
        <b-button @click="addDashlet">Add Item</b-button>
        <b-button @click="toggleEdit">End editor mode</b-button>
      </b-col>
    </b-row>
    <b-row v-if="SessionManager().hasFlag(FeatureFlag.DASHLETSCONFIGURATION) && hasChildren" class="mb-2 mt-1">
      <b-col>
        <div style="position: relative; height: 0">
          <div style="position: absolute; right: 6px; top: 12px; z-index: 2">
            <b-button @click="handleRefresh">
              <font-awesome-icon :icon="['fas', 'rotate']"/>
              <!--              <span v-text="$tr('refresh-button', 'Refresh')"></span>-->
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row ref="getStartedContent" class="mt-2"
           v-if="(SessionManager().isOpen() || SessionManager().isDev()) &&
           SessionManagerAutoconf() !== 'supplier' && SessionManagerAutoconf() !== 'suppliers'" >
      <GetStartedWelcomeScreen></GetStartedWelcomeScreen>
    </b-row>
    <b-row ref="dashletsContainer" class="mt-2">
    </b-row>
  </b-container>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Rpc from "@/Rpc";
import Dashlets from "@/components/dashlets";
import Vue from "vue";
import {register} from "@/components/dashboard/GlobalDashlet";
import SingleExecution from "@/utils/SingleExecution";
import ActivityManager from "@/activity/ActivityManager";
import DashletsSelect from "@/components/dashboard/DashletsSelect.vue";
import FeatureFlag from "@/server/com/silkplm/rpc/FeatureFlag";
import SessionManager from "@/utils/SessionManager";
import GetStartedWelcomeScreen from "@/components/dashboard/GetStartedWelcomeScreen.vue";
import UnreadMessagesDashletForOffers from "@/components/dashlets/UnreadMessagesDashletForOffers.vue";
import UnreadMessagesDashletForInquiry from "@/components/dashlets/UnreadMessagesDashletForInquiry.vue";
import UnreadMessagesDashletForPPSample from "@/components/dashlets/UnreadMessagesDashletForPPSample.vue";
import UnreadMessagesDashletForSample from "@/components/dashlets/UnreadMessagesDashletForSample.vue";

export default {
  name: "DashletsHome",
  components: {GetStartedWelcomeScreen},
  computed: {
    FeatureFlag() {
      return FeatureFlag
    }
  },

  async mounted() {
    if (!SessionManager.hasFlag(FeatureFlag.DASHLETSCONFIGURATION)) {
      return;
    }
    if (SessionManager.isAdmin) {
      return;
    }
    this.configSaveExecutor = new SingleExecution();

    register(this);

    this.instanceByUUID = {};

    this.allDashletConfigs = await Rpc.Dashboards.getAvailableDashlets();
    this.allDashletConfigsByName = {};
    for (let dc of this.allDashletConfigs) {
      this.allDashletConfigsByName[dc.name] = dc;
    }

    this.dashletsRenderersByName = {};

    let preparedDashlets = [...Dashlets];
    if (!SessionManager.hasFlag(FeatureFlag.SUPPLIERS_MARKET)) {
      const excludedNames = [
        'UnreadMessagesDashletForInquiry',
        'UnreadMessagesDashletForSample'
      ];

      preparedDashlets = Dashlets.filter(dashlet => !excludedNames.includes(dashlet.name));
    }

    if (!SessionManager.hasFlag(FeatureFlag.CONTRACTORS_MARKET)) {
      const excludedNames = [
        'UnreadMessagesDashletForOffers',
        'UnreadMessagesDashletForPPSample'
      ];

      preparedDashlets = Dashlets.filter(dashlet => !excludedNames.includes(dashlet.name));
    }

    for (let dashlet of preparedDashlets) {

      if (!this.allDashletConfigsByName.hasOwnProperty(dashlet.name)) {
        console.log(`${dashlet.name} not found on the server end`)
        continue;
      }

      let opt = {...dashlet, router: this.$router};
      this.dashletsRenderersByName[dashlet.name] = Vue.extend(opt);
    }

    this.config = await Rpc.Dashboards.getDashletsUserConfig();
    let updateConf = false;
    if (!this.config) {
      this.config = {}
      updateConf = true;
    }
    if (!this.config.hasOwnProperty('items')) {
      this.config.items = [];
      updateConf = true;
    }

    if (updateConf) {
      await Rpc.Dashboards.saveDashletsUserConfig(this.config);
    }
    this.initialRender();
    this.checkChildren();

    if (SessionManager.hasFlag(FeatureFlag.SUPPLIERS_MARKET) && (
        this.SessionManagerAutoconf() === 'supplier' || this.SessionManagerAutoconf() === 'suppliers') &&
        !this.config.items.some(item =>
            item.name === "UnreadMessagesDashletForInquiry" || item.name === "UnreadMessagesDashletForSample"
        )) {
        this.loadDashlet("UnreadMessagesDashletForInquiry");
        this.loadDashlet("UnreadMessagesDashletForSample");
    }
  },

  methods: {
    SessionManager() {
      return SessionManager
    },

    SessionManagerAutoconf() {
      return SessionManager.configManager?.load("tour.autostart.autoconf");
    },

    ...Activity.methods,

    getTitle() {
      return "Get Started!";
    },

    canClose() {
      return false;
    },

    multipleInstances() {
      return Activity.BLOCK;
    },

    checkChildren() {
      const dashletsContainer = this.$refs.dashletsContainer;
      if (dashletsContainer.children.length) {
        this.hasChildren = true;
      } else {
        this.hasChildren = false;
      }
    },

    isClosable() {
      return false;
    },

    async handleRefresh() {
      try {
        // Pobieranie aktualnych konfiguracji
        this.allDashletConfigs = await Rpc.Dashboards.getAvailableDashlets();
        this.config = await Rpc.Dashboards.getDashletsUserConfig();

        // Usuwanie istniejących dashboardów
        this.removeExistingDashlets();

        // Renderowanie zaktualizowanych dashboardów
        this.initialRender();
      } catch (error) {
        console.error('Błąd podczas odświeżania danych:', error);
      }
    },

    initialRender() {
      for (let dashletConf of this.config.items) {
        let dashletName = dashletConf.name;
        if (!this.dashletsRenderersByName.hasOwnProperty(dashletName)) {
          continue;
        }
        this.createDashlet(this.dashletsRenderersByName[dashletName], this.allDashletConfigsByName[dashletName], dashletConf);
      }
    },

    loadDashlet(selection){
      let conf = {
        name: selection,
        uuid: crypto.randomUUID(),
        instanceConfig: {}
      };

      this.config.items.push(conf);
      this.createDashlet(this.dashletsRenderersByName[conf.name], this.allDashletConfigsByName[conf.name], conf);

      this.scheduleConfUpdate();
      this.hasChildren = true;
    },

    async addDashlet() {
      let selectActivity = await ActivityManager.showActivity(DashletsSelect);
      let selection = await selectActivity.getResult();
      if (selection) {
        this.loadDashlet(selection);
      }
    },

    generateUniqueId() {
      return this.nextId++;
    },

    createDashlet(rendererClazz, dashletTypeConfig, dashletInstConfig) {
      let uniqueId = this.generateUniqueId();  // Generowanie unikalnego ID

      let createParameters = {
        uuid: dashletInstConfig.uuid,
        dashletConfig: dashletTypeConfig,
        config: dashletInstConfig.instanceConfig,
        id: uniqueId  // Dodanie unikalnego ID do parametrów
      };

      let instance = new rendererClazz({propsData: createParameters});
      instance.beforeMount?.();
      this.$children.push(instance);
      instance.$parent = this;
      instance.$root = this.$root;
      instance.$mount();

      let colDiv;
      if (dashletTypeConfig.frameStyle === "CARD" || dashletTypeConfig.frameStyle === "CARD_NO_HEADER") {
        colDiv = document.createElement("div");
        colDiv.setAttribute("class", "mb-1 px-0 px-lg-1 col " + dashletTypeConfig.layout);

        let cardDiv = document.createElement("div");
        cardDiv.setAttribute("class", "card");
        colDiv.appendChild(cardDiv);
        if (dashletTypeConfig.frameStyle === "CARD") {
          let headDiv = document.createElement("div");
          headDiv.setAttribute("class", "card-header");
          headDiv.textContent = dashletTypeConfig.title;
          cardDiv.appendChild(headDiv);
        }

        let bodyDiv = document.createElement("div");
        bodyDiv.setAttribute("class", "card-body px-0 px-md-1");
        cardDiv.appendChild(bodyDiv);

        bodyDiv.appendChild(instance.$el);
        this.$refs.dashletsContainer.appendChild(colDiv);
      } else {
        colDiv = document.createElement("div");
        colDiv.setAttribute("class", "mb-1 px-0 px-lg-1 col " + dashletTypeConfig.layout);

        this.$refs.dashletsContainer.appendChild(colDiv);
        colDiv.appendChild(instance.$el);
      }

      let changeHandler = () => {
        this.scheduleConfUpdate();
      }
      instance.$on('config-change', changeHandler);
      instance.$on('resize', classList => {
        colDiv.setAttribute("class", "mb-1 px-0 px-lg-1 col " + classList);
      });

      this.instanceByUUID[dashletInstConfig.uuid] = {
        ...createParameters,
        instance,
        colDiv,
        trashDiv: null,
        changeHandler
      }

      if (this.editMode) {
        this.attachTrashButton(this.instanceByUUID[dashletInstConfig.uuid]);
        this.instanceByUUID[dashletInstConfig.uuid].instance.editMode = true;
      }
    },

    removeItem(uuid) {
      let inst = this.instanceByUUID[uuid];
      inst.colDiv.parentNode?.removeChild?.(inst.colDiv);
      let instance = inst.instance;

      this.$children.splice(this.$children.indexOf(instance), 1);
      instance.$parent = null;
      instance.$root = null;
      instance.$destroy();

      instance.$off('config-change', inst.changeHandler);

      delete this.instanceByUUID[uuid];

      let confIndex = this.config.items.findIndex(conf => conf.uuid === uuid);
      this.config.items.splice(confIndex, 1);
      this.scheduleConfUpdate();
      this.checkChildren();
    },

    toggleEdit() {
      if (this.editMode) {
        this.editMode = false;
        for (let instanceUUID in this.instanceByUUID) {
          let instance = this.instanceByUUID[instanceUUID];
          if (instance) {
            instance.trashDiv?.parentNode?.removeChild?.(instance.trashDiv);
            instance.trashDiv = null;
            instance.instance.editMode = false;
          }
        }
      } else {
        this.editMode = true;
        for (let instanceUUID in this.instanceByUUID) {
          let instance = this.instanceByUUID[instanceUUID];
          instance.instance.editMode = true;
          this.attachTrashButton(instance);
        }
      }
    },

    attachTrashButton(instance) {
      let trashDiv = document.createElement("div");
      trashDiv.setAttribute('style', 'height:0; width:100%; position:relative; z-index:1002');

      let trashBtn = document.createElement("button");
      trashBtn.setAttribute('class', 'btn btn-secondary');
      trashBtn.setAttribute('style', 'position:absolute; top:5px; right:5px');
      trashBtn.innerText = "✕";

      trashBtn.addEventListener("click", () => this.removeItem(instance.uuid));

      trashDiv.appendChild(trashBtn);

      instance.colDiv.insertBefore(trashDiv, instance.colDiv.firstChild);
      instance.trashDiv = trashDiv;
    },

    scheduleConfUpdate() {
      let conf = JSON.stringify(this.config);
      this.configSaveExecutor.scheduleExecution(conf, async () => {
        let res = await Rpc.Dashboards.saveDashletsUserConfig(this.config);
      })
    },

    removeExistingDashlets() {
      // Usuwanie istniejących dashboardów
      for (let uuid in this.instanceByUUID) {
        let instance = this.instanceByUUID[uuid];
        instance.colDiv.parentNode?.removeChild?.(instance.colDiv);
        let componentInstance = instance.instance;

        this.$children.splice(this.$children.indexOf(componentInstance), 1);
        componentInstance.$parent = null;
        componentInstance.$root = null;
        componentInstance.$destroy();

        componentInstance.$off('config-change', instance.changeHandler);
      }

      // Czyszczenie instancji
      this.instanceByUUID = {};
    }
  },

  props: {},

  data: function () {
    return {
      permissions: new PermissionsSet(),
      editMode: false,
      hasChildren: false,
      nextId: 1
    };
  }
};
</script>
